import React, { useState } from "react";
import dayjs from "dayjs";

import HWLog from "../../HWLibrary/HWLog";
import { s360ConfigService } from "../../Services/S360Config";
function MessageA13(props) {
  const [a13State, setA13State] = useState({
    value: props.entry.text_data.data[0].value,
    actionDone: false,
  })

  const onMouseEnterButton = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    e.target.style.color = s360ConfigService.config?.customDesign?.messageA13ButtonMouseEnter?.color ?? "#f8f5f5";
    e.target.style.backgroundColor = s360ConfigService.config?.customDesign?.messageA13ButtonMouseEnter?.background ?? "#2935dd";
  };

  const onMouseLeaveButton = (e) => {
    if (!e.target) {
      return;
    }

    e.target.style.color = s360ConfigService.config?.customDesign?.messageA13ButtonMouseLeave?.color ?? "#0092ed";
    e.target.style.backgroundColor = s360ConfigService.config?.customDesign?.messageA13ButtonMouseLeave?.background ?? "#fff"
  };

  const onListItemSelect = (item) => {
    if (a13State.actionDone) {
      setA13State(prev => ({ ...prev, value: false }));
    } else {
      setA13State(prev => ({ ...prev, value: item.target.value }));
    }
  };

  const onSubmit = (e) => {
    onMouseLeaveButton(e);
    setA13State(prev => ({ ...prev, value: false, actionDone: true }));
    props.actions.sendMessage(a13State.value);
    var n = document.getElementsByClassName(
      "s360-message-box-custom-a15-received"
    );
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
    }
  };

  const parseListValues = () => {
    try {
      return props.entry.text_data.data || [];
    } catch (error) {
      HWLog.warn("Invalid List Data for Custom Type A13:");
    }
    return [];
  };

  const messageBoxStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA13Box;
  };

  const messageTimeClassName = () => {
    return "s360-message-time-received";
  };

  const messageTimeStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA13Time;
  };

  const messageBoxSubmitStyle = () => {
    return {
      marginLeft: "15px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#0092ed",
      borderRadius: 20,
      color: "#0092ed",
      backgroundColor: "#fff",
      fontWeight: 500,
      ...s360ConfigService.config?.customDesign?.messageA13Submit
    };
  };

  const selectOptionsStyle = {
    control: (provided) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
      borderRadius: "0px",
      width: "100% !important",
      "&:hover": {
        border: "none",
      },
      ...s360ConfigService.config?.customDesign?.messageA13SelectControl
    }),
    singleValue: (provided) => ({
      ...provided,
      ...s360ConfigService.config?.customDesign?.messageA13SelectSingleValue
    }),
    option: (styles, { isDisabled, isSelected }) => {
      const design = s360ConfigService.config?.customDesign?.messageA13SelectOption;
      return {
        ...styles,
        fontFamily:"sans-serif",
        fontWeight: 500,
        fontSize: "12px",
        backgroundColor: isDisabled ? null : isSelected ? (design?.color ?? "black") : null,
        color: isSelected ? "white" : (design?.color ?? "black"),
        ":active": {
          ...styles[":active"],
          backgroundColor: null,
        },
        borderBottom: "1px solid #ccc",
        ...design
      };
    },
  };

  const optionsArray = parseListValues().map((item) => {
    return { value: item.value, label: item.name };
  });
  // console.log(props.entry.text_data.data,"A13 DATA")
  return (
    <div
      aria-disabled={!a13State.value}
      className="s360-message-cotainer-custom-a13-received"
    >
      <div
        className="s360-message-box-custom-a13-received"
        style={messageBoxStyle()}
      >
        <select onChange={onListItemSelect} style={selectOptionsStyle}>
          {optionsArray.map((oneoption, index) => (
            <option key={index}>{oneoption.value}</option>
          ))}
        </select>
      </div>
      {props.isLastEntry && props.sentTimestamp && (
        <div
          className={messageTimeClassName()}
          style={messageTimeStyle()}
        >
          {dayjs.unix(props.sentTimestamp).format("DD MMM h:mm a")}
        </div>
      )}
      <div className="s360-message-cotainer-received">
        <button
          disabled={props.disabled}
          className="s360-message-box-custom-a15-received"
          onClick={onSubmit}
          onMouseEnter={onMouseEnterButton}
          onMouseLeave={onMouseLeaveButton}
          style={messageBoxSubmitStyle()}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default MessageA13;
